/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropcreated1Inputs */

const en_dropcreated1 = /** @type {(inputs: Dropcreated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop created`)
};

const de_dropcreated1 = /** @type {(inputs: Dropcreated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop erstellt`)
};

/**
* | output |
* | --- |
* | "Drop created" |
*
* @param {Dropcreated1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropcreated1 = /** @type {((inputs?: Dropcreated1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropcreated1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropcreated1(inputs)
	return de_dropcreated1(inputs)
});
export { dropcreated1 as "dropCreated" }